import { InformationCircleIcon } from '@heroicons/react/24/solid'
import PropTypes from 'prop-types'
import { Heading } from '../../../components/ui/Heading'
import { useLanguageContext, useUserContext } from '../../../context'

export default function ChallengeCard({ challenge, onClickMoreInformation }) {
  const { language } = useLanguageContext()
  const { activeSpace } = useUserContext()
  const hasCompletedOnboarding = activeSpace?.hasCompletedOnboarding

  return (
    <div className='relative flex h-full flex-col rounded-lg border border-softGrey bg-lightPaleGrey p-4'>
      <button
        title='More information'
        onClick={onClickMoreInformation}
        className='absolute right-4 top-4'
        disabled={!hasCompletedOnboarding}
      >
        <InformationCircleIcon
          className={`size-5 ${!hasCompletedOnboarding ? 'cursor-not-allowed text-lightGrey opacity-50' : 'text-mediumGrey'}`}
        />
      </button>

      <div className='flex w-full flex-row items-center'>
        <div
          className='flex size-12 items-center justify-center rounded-full'
          style={{ backgroundColor: challenge.backgroundColor }}
        >
          <img
            src={challenge.card.image}
            className='size-8 object-contain'
            style={{ backgroundColor: challenge.backgroundColor }}
          />
        </div>

        <div className='ml-2 flex flex-1 flex-col'>
          <div className='flex w-full'>
            <Heading className={'w-11/12'} level={4}>
              {challenge.dimensionSynonym[language]}{' '}
            </Heading>
          </div>

          <p className='text-xs font-normal text-[#374151]'>
            {challenge.title[language]}
          </p>
        </div>
      </div>
      <div className='mb-5 mt-4'>
        <p className='text-sm leading-normal text-[#374151]'>
          {challenge.measuring[language]}
        </p>
      </div>
      {/* <div className='mt-auto flex flex-row items-center gap-x-4'>
        <Button.SecondaryXL
          onClick={() => {
            trackEvent(trackEvents.PRESSED_TRYOUT_CHALLENGE)
            window.open(
              getTryoutChallengeLink({
                exam_id: challenge.exam_id,
                language,
                available_languages: challenge.available_languages
              })
            )
          }}
          text={t('discover.create_career.step_2.tryNow')}
        />
        <button
          onClick={onClickMoreInformation}
          className='text-sm font-medium text-primaryBlue'
        >
          {t('discover.create_career.step_2.details')}
        </button>
      </div> */}
    </div>
  )
}

ChallengeCard.propTypes = {
  challenge: PropTypes.object.isRequired,
  hasInfoIcon: PropTypes.bool,
  onClickMoreInformation: PropTypes.func.isRequired
}
